import { fgFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import ScaleIcon from "@redotech/redo-icons/scales-01.svg";
import { BooleanFilterOperator } from "@redotech/redo-views-common/advanced-filters/boolean-filter";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgFilterEntries.usedWeightLearning;

export const UsedWeightLearningFilter: BooleanTableFilter = {
  type: entry.type,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: ScaleIcon,
  displayName: entry.displayName,
  label: "Weight learning",
  boolDisplay: { falseDisplay: "not used", trueDisplay: "used" },
};
